<div class="layout-container" style="display: flex; flex-direction: column">
  <router-outlet></router-outlet>
</div>
